import { useEffect, useState } from "react";

interface Props {
  label: string;
  value: string;
  onChange: (next: string) => void;
  placeholder?: string;
}

// Color swatch + hex text input that stay in sync, matching the original
// _initColorSync helper in platform.html.
export function ColorField({ label, value, onChange, placeholder }: Props) {
  const [hex, setHex] = useState(value.toUpperCase());

  useEffect(() => {
    setHex(value.toUpperCase());
  }, [value]);

  return (
    <div className="field">
      <label>{label}</label>
      <div className="color-input-wrap">
        <input
          type="color"
          value={value}
          onChange={(e) => {
            onChange(e.target.value);
            setHex(e.target.value.toUpperCase());
          }}
        />
        <input
          type="text"
          className="color-hex-input"
          maxLength={7}
          placeholder={placeholder}
          value={hex}
          onChange={(e) => {
            const v = e.target.value;
            setHex(v);
            if (/^#[0-9a-fA-F]{6}$/.test(v.trim())) onChange(v.trim());
          }}
        />
      </div>
    </div>
  );
}
